/* Cart discount codes. Markup: snippets/cart-discount-form.liquid */
(function () {
  if (window.__cartDiscountInit) return;
  window.__cartDiscountInit = true;

  const FORM_SELECTOR = 'form.js-cart-discount-form';
  const FALLBACK_MESSAGES = {
    success: "Coupon code '{{code}}' applied, you saved {{amount}}!",
    failed: "Code '{{code}}' is not valid on the items in your bag.",
    worse: 'A better discount is already applied to your cart.',
    duplicate: "Code '{{code}}' is already applied.",
  };
  let inFlight = false;

  const routes = () => (window.FoxTheme && FoxTheme.routes) || {};
  const cartJsUrl = () => (routes().cart_url || '/cart') + '.js';
  const cartUpdateUrl = () => routes().cart_update_url || '/cart/update.js';

  // Same section list the theme's own quantity updates use.
  function sectionsToRender() {
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
    );
    return [...new Set(sections)];
  }

  // Source of truth is cart.discount_codes; invalid codes come back with applicable: false.
  function appliedCodes(cart) {
    const list = (cart && cart.discount_codes) || [];
    return [...new Set(list.filter((d) => d && d.code && d.applicable).map((d) => String(d.code).toUpperCase()))];
  }

  async function fetchCart() {
    const res = await fetch(cartJsUrl(), { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!res.ok) throw new Error('cart.js ' + res.status);
    return res.json();
  }

  // Shopify replaces the whole code list on every call, so always send the full set.
  async function postCodes(codes, render) {
    const body = { discount: codes.join(',') };
    if (render) {
      body.sections = sectionsToRender();
      body.sections_url = window.location.pathname;
    }
    const res = await fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error('cart/update.js ' + res.status);
    return res.json();
  }

  function rerender(cart) {
    if (cart.sections && window.FoxTheme && FoxTheme.pubsub) {
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { sources: 'cart-discount', cart });
    }
    addMissingPills(cart);
  }

  // Free-shipping codes have no allocation, so Liquid can't draw their pill.
  function addMissingPills(cart) {
    const codes = appliedCodes(cart);
    document.querySelectorAll('.cart-discount').forEach((scope) => {
      const box = scope.querySelector('[data-discount-pills]');
      const tpl = scope.querySelector('.js-cart-discount-pill-template');
      if (!box || !tpl) return;
      codes.forEach((code) => {
        if (box.querySelector(`[data-discount-code="${CSS.escape(code)}"]`)) return;
        const html = tpl.innerHTML.replace(/__CODE__/g, escapeHtml(code));
        box.insertAdjacentHTML('beforeend', html);
      });
    });
  }

  function messages() {
    const el = document.querySelector('.js-cart-discount-strings');
    let custom = {};
    try {
      custom = el ? JSON.parse(el.textContent) : {};
    } catch (e) {}
    const out = Object.assign({}, FALLBACK_MESSAGES);
    Object.keys(custom).forEach((k) => {
      if (custom[k]) out[k] = custom[k];
    });
    return out;
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  }

  // Merchant copy may contain HTML; shopper input is escaped before it goes in.
  function renderMessage(key, vars) {
    let out = messages()[key] || '';
    Object.keys(vars).forEach((name) => {
      out = out.replace(new RegExp(`\\{\\{\\s*${name}\\s*\\}\\}`, 'g'), escapeHtml(vars[name]));
    });
    return out;
  }

  function formatMoney(cents) {
    if (window.FoxTheme && FoxTheme.Currency && FoxTheme.settings && FoxTheme.settings.moneyFormat) {
      return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
    }
    return '$' + ((cents || 0) / 100).toFixed(2);
  }

  function showMessage(html, success) {
    document.querySelectorAll('.cart-discount [data-discount-message]').forEach((box) => {
      box.querySelector('[data-discount-message-text]').innerHTML = html;
      box.classList.toggle('cart-discount__message--success', !!success);
      box.hidden = false;
    });
  }

  function hideMessages() {
    document.querySelectorAll('.cart-discount [data-discount-message]').forEach((box) => (box.hidden = true));
  }

  function setLoading(loading) {
    document.querySelectorAll(FORM_SELECTOR).forEach((form) => {
      form.classList.toggle('is-loading', loading);
      const btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = loading;
    });
  }

  function clearInputs() {
    document.querySelectorAll(`${FORM_SELECTOR} [name="discount"]`).forEach((input) => (input.value = ''));
  }

  async function applyCode(rawCode) {
    const code = (rawCode || '').trim().toUpperCase();
    if (!code || inFlight) return;
    inFlight = true;
    setLoading(true);
    hideMessages();

    try {
      const before = await fetchCart();
      const prev = appliedCodes(before);
      const savedBefore = before.total_discount || 0;

      if (prev.includes(code)) {
        clearInputs();
        showMessage(renderMessage('duplicate', { code }), false);
        return;
      }

      // 1. Try stacking it on top of the current codes.
      const stacked = await postCodes([...prev, code], true);
      if (appliedCodes(stacked).includes(code)) {
        const saved = stacked.total_discount || 0;
        if (savedBefore > 0 && saved <= savedBefore) {
          await postCodes(prev, false);
          showMessage(renderMessage('worse', { code }), false);
          return;
        }
        rerender(stacked);
        clearInputs();
        showMessage(renderMessage('success', { code, amount: formatMoney(saved) }), true);
        return;
      }

      // 2. Doesn't combine with the current codes: keep it alone only if it saves more.
      if (prev.length) {
        const solo = await postCodes([code], true);
        if (appliedCodes(solo).includes(code)) {
          const saved = solo.total_discount || 0;
          if (saved > savedBefore) {
            rerender(solo);
            clearInputs();
            showMessage(renderMessage('success', { code, amount: formatMoney(saved) }), true);
            return;
          }
          await postCodes(prev, false);
          showMessage(renderMessage('worse', { code }), false);
          return;
        }
      }

      // 3. Not valid. Put the previous codes back so the rejected one doesn't reach checkout.
      await postCodes(prev, false);
      showMessage(renderMessage('failed', { code }), false);
    } catch (e) {
      console.error(e);
      showMessage('Something went wrong applying that code. Please try again.', false);
    } finally {
      inFlight = false;
      setLoading(false);
    }
  }

  async function removeCode(code) {
    if (inFlight) return;
    inFlight = true;
    setLoading(true);
    hideMessages();
    try {
      const remaining = appliedCodes(await fetchCart()).filter((c) => c !== code);
      rerender(await postCodes(remaining, true));
    } catch (e) {
      console.error(e);
      showMessage('Could not remove that code. Please try again.', false);
    } finally {
      inFlight = false;
      setLoading(false);
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest && e.target.closest(FORM_SELECTOR);
    if (!form) return;
    e.preventDefault();
    const input = form.querySelector('[name="discount"]');
    applyCode(input ? input.value : '');
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest) return;
    const remove = e.target.closest('[data-discount-remove]');
    if (remove) {
      e.preventDefault();
      removeCode((remove.getAttribute('data-discount-remove') || '').trim().toUpperCase());
      return;
    }
    const close = e.target.closest('[data-discount-message-close]');
    if (close) {
      e.preventDefault();
      close.closest('[data-discount-message]').hidden = true;
    }
  });

  // Theme re-renders the drawer after quantity changes; redraw free-shipping pills.
  document.addEventListener('cart:updated', (e) => {
    if (e.detail && e.detail.cart) addMissingPills(e.detail.cart);
  });
})();